module.exports = __webpack_public_path__ + "img/gw-mail.a2174d9f.png";